module.exports = __webpack_public_path__ + "assets/img/logobd.2aba1902.png";